(function () {

  /* ==========================
     DESKTOP SLIDER
  ========================== */

  function initDesktopSlider() {
    const slider = document.querySelector('[data-bh-desktop-slider]');
    const pagination = document.querySelector('[data-bh-desktop-pagination');

    if (!slider || !pagination) return;

    const slides = slider.querySelectorAll('.bh-slider-desktop__slide');
    const dots = pagination.querySelectorAll('button');

    if (!slides.length || !dots.length) return;

    let index = 0;
    const total = slides.length;

    function goTo(i) {
      slides[index].classList.remove('is-active');
      dots[index].classList.remove('is-active');

      index = (i + total) % total;

      slides[index].classList.add('is-active');
      dots[index].classList.add('is-active');
    }

    let interval = setInterval(() => {
      goTo(index + 1);
    }, 7000);

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        clearInterval(interval);
        goTo(i);

        interval = setInterval(() => {
          goTo(index + 1);
        }, 7000);
      });
    });
  }

  /* ==========================
     MOBILE SLIDER
  ========================== */

  function initMobileSlider() {

    const container = document.querySelector('.bh-slider-mobile');
    const slidesContainer = document.querySelector('[data-bh-mobile-slider]');
    const indicator = document.querySelector('[data-bh-mobile-indicator]');

    if (!container || !slidesContainer) return;

    const firstSlide = slidesContainer.firstElementChild;
    if (!firstSlide) return;

    const cloneSlide = firstSlide.cloneNode(true);
    slidesContainer.appendChild(cloneSlide);

    const totalRealSlides = slidesContainer.children.length - 1;

    let index = 0;
    let startY = 0;
    let endY = 0;
    let isTransitioning = false;
    let sliderInterval;

    if (indicator) {
      setTimeout(() => {
        indicator.classList.add('is-hidden');
      }, 3000);
    }

    function updateEffects() {
      const slides = slidesContainer.querySelectorAll('.bh-slider-mobile__slide');

      slides.forEach((slide, i) => {
        if (i === index || (index === totalRealSlides && i === totalRealSlides)) {
          slide.classList.add('is-active');
        } else {
          slide.classList.remove('is-active');
        }
      });
    }

    function goToSlide(i, immediate = false) {

      if (isTransitioning && !immediate) return;

      isTransitioning = true;
      index = i;

      slidesContainer.style.transition = immediate
        ? 'none'
        : 'transform .7s cubic-bezier(0.4,0,0.2,1)';

      slidesContainer.style.transform =
        `translateY(-${index * 100}%)`;

      updateEffects();

      if (!immediate) {
        setTimeout(() => {

          if (index >= totalRealSlides) {
            goToSlide(0, true);
          } else if (index < 0) {
            goToSlide(totalRealSlides - 1, true);
          }

          isTransitioning = false;

        }, 700);
      } else {
        isTransitioning = false;
      }
    }

    function startAutoplay() {

      clearInterval(sliderInterval);

      sliderInterval = setInterval(() => {
        goToSlide(index + 1);
      }, 7000);
    }

    container.addEventListener('touchstart', (e) => {
      startY = e.touches[0].clientY;
    }, { passive: true });

    container.addEventListener('touchend', (e) => {

      endY = e.changedTouches[0].clientY;

      const threshold = 40;

      if (startY - endY > threshold) {

        goToSlide(index + 1);

      } else if (endY - startY > threshold) {

        if (index === 0) {

          goToSlide(totalRealSlides, true);

          setTimeout(() => {
            goToSlide(totalRealSlides - 1);
          }, 20);

        } else {

          goToSlide(index - 1);

        }
      }

    }, { passive: true });

    updateEffects();
    goToSlide(0, true);
    startAutoplay();
  }

  /* ==========================
     INIT
  ========================== */

  function initAll() {
    initDesktopSlider();
    initMobileSlider();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

})();